import restClient from '../restClient';
export const SUBMITTED_CORPORATE_INFORMATION = 'SUBMITTED_CORPORATE_INFORMATION';
export const CORPORATE_INFORMATION_SAVE_ERROR = 'CORPORATE_INFORMATION_SAVE_ERROR';
export const SUBMITTING_CORPORATE_INFORMATION = 'SUBMITTING_CORPORATE_INFORMATION';
const corporateInformationSubmitted = () => ({
  type: SUBMITTED_CORPORATE_INFORMATION
});
const submittingCorporateInformation = () => ({
  type: SUBMITTING_CORPORATE_INFORMATION
});
export const doConfirmCorporateInformation = corporateInformation => async dispatch => {
  dispatch(submittingCorporateInformation());
  try {
    await restClient.confirmCorporateInformation(corporateInformation);
    dispatch(corporateInformationSubmitted());
  } catch (e) {
    dispatch({
      type: CORPORATE_INFORMATION_SAVE_ERROR,
      error: e
    });
  }
};